exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.email-input[data-v-47d02fb7] {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tborder: 1px solid #ccc;\n\tpadding: 5px;\n\twidth: 100%;\n\tborder-radius: 4px;\n}\n.email-item[data-v-47d02fb7] {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 5px;\n\tmargin-bottom: 5px;\n\tborder-radius: 3px;\n\tbackground-color: #eee;\n\tpadding: 3px 6px;\n}\n.email-item span[data-v-47d02fb7] {\n\tmargin-right: 5px;\n}\n.email-item button[data-v-47d02fb7] {\n\tborder: none;\n\tbackground-color: transparent;\n\tcolor: #777;\n\tcursor: pointer;\n\tfont-size: 14px;\n\tmargin-left: 5px;\n}\n", ""]);

// exports
